(function () {
  if (window.__sawayCarouselTameInit) return;
  window.__sawayCarouselTameInit = true;

  var mobileMql = window.matchMedia('(max-width: 575px)');

  function getBusyMs(carousel) {
    var raw = carousel.getAttribute('xo-speed');
    var n = parseInt(raw, 10);
    if (!isFinite(n) || n <= 0) n = 300;
    return n + 40;
  }

  function findArrowFromEvent(e) {
    var path = typeof e.composedPath === 'function' ? e.composedPath() : null;
    if (path) {
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (node && node.nodeType === 1) {
          var tag = node.tagName && node.tagName.toLowerCase();
          if (tag === 'xo-carousel-prev' || tag === 'xo-carousel-next') return node;
          if (
            node.classList &&
            (node.classList.contains('saway-mob-prev') ||
              node.classList.contains('saway-mob-next'))
          ) {
            return node;
          }
        }
      }
      return null;
    }
    return e.target && e.target.closest
      ? e.target.closest(
          'xo-carousel-prev, xo-carousel-next, .saway-mob-prev, .saway-mob-next'
        )
      : null;
  }

  function nativeStep(carousel, dir) {
    var inner = carousel.querySelector('.saway-mob-inner');
    if (!inner) return;
    var slides = inner.querySelectorAll('.saway-mob-slide');
    if (!slides.length) return;

    var innerRect = inner.getBoundingClientRect();
    var innerStyles = window.getComputedStyle(inner);
    var paddingLeft = parseFloat(innerStyles.paddingLeft) || 0;
    var paddingRight = parseFloat(innerStyles.paddingRight) || 0;
    var currentScroll = inner.scrollLeft;
    var maxScroll = inner.scrollWidth - inner.clientWidth;

    // Compute each slide's snap-start scrollLeft.
    var snapPoints = [];
    var lastIdx = slides.length - 1;
    for (var i = 0; i < slides.length; i++) {
      var rect = slides[i].getBoundingClientRect();
      var offsetInScroll = rect.left - innerRect.left + currentScroll;
      var snap;
      if (i === lastIdx) {
        // Last slide aligns to end so trailing whitespace is avoided.
        snap = offsetInScroll + rect.width - inner.clientWidth + paddingRight;
      } else {
        snap = offsetInScroll - paddingLeft;
      }
      if (snap < 0) snap = 0;
      if (snap > maxScroll) snap = maxScroll;
      snapPoints.push(snap);
    }

    // Find current index = the snap point closest to current scroll.
    var currentIndex = 0;
    var minDist = Infinity;
    for (var j = 0; j < snapPoints.length; j++) {
      var d = Math.abs(snapPoints[j] - currentScroll);
      if (d < minDist) {
        minDist = d;
        currentIndex = j;
      }
    }

    var targetIndex = currentIndex + dir;
    if (targetIndex < 0) targetIndex = 0;
    if (targetIndex > lastIdx) targetIndex = lastIdx;

    var target = snapPoints[targetIndex];
    if (typeof inner.scrollTo === 'function') {
      inner.scrollTo({ left: target, behavior: 'smooth' });
    } else {
      inner.scrollLeft = target;
    }
  }

  // Replace xo-carousel-inner / list / slide custom elements with plain divs
  // on mobile. This detaches xo's touch handlers entirely (custom-element
  // connectedCallback bindings die with the element), allowing the browser's
  // native overflow-x scroll-snap to handle gestures with zero JS interference.
  function migrateCarouselToNative(carousel) {
    if (carousel.dataset.sawayMobReady === '1') return;

    // Bail before marking ready: if the inner structure is not available yet
    // we must leave the carousel unmarked so xo-carousel keeps working as a
    // fallback and a later pass can still migrate it.
    var oldInner = carousel.querySelector('xo-carousel-inner');
    if (!oldInner) return;
    var oldList = oldInner.querySelector('xo-carousel-list');
    if (!oldList) return;

    carousel.dataset.sawayMobReady = '1';
    carousel.classList.add('saway-mob-active');

    var newInner = document.createElement('div');
    newInner.className = 'saway-mob-inner';

    var newList = document.createElement('div');
    newList.className = 'saway-mob-list';

    var oldSlides = oldList.querySelectorAll('xo-carousel-slide');
    for (var i = 0; i < oldSlides.length; i++) {
      var oldSlide = oldSlides[i];
      var newSlide = document.createElement('div');
      newSlide.className = 'saway-mob-slide';
      while (oldSlide.firstChild) newSlide.appendChild(oldSlide.firstChild);
      newList.appendChild(newSlide);
    }

    newInner.appendChild(newList);
    oldInner.parentNode.replaceChild(newInner, oldInner);
  }

  function migrateAll() {
    if (!mobileMql.matches) return;
    var carousels = document.querySelectorAll(
      'xo-carousel[data-saway-native-mobile]'
    );
    for (var i = 0; i < carousels.length; i++) {
      migrateCarouselToNative(carousels[i]);
    }
  }

  function init() {
    migrateAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Section editor reload safety: re-migrate when sections are re-rendered.
  document.addEventListener('shopify:section:load', migrateAll);

  // Async content safety: carousels injected after load (e.g. product
  // recommendations fetched by xo-product-recommendations) never fire
  // shopify:section:load, so watch for them and migrate once they appear.
  // Migration runs synchronously inside the observer callback so it happens
  // before xo-carousel's own deferred (requestAnimationFrame) restructuring —
  // the same ordering that makes load-time migration reliable.
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      if (!mobileMql.matches) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('xo-carousel[data-saway-native-mobile]')) ||
            (node.querySelector && node.querySelector('xo-carousel[data-saway-native-mobile]'))
          ) {
            migrateAll();
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Block any residual xo-carousel touch listeners (e.g. on the parent
  // element itself) so they cannot call preventDefault on touchmove and kill
  // native scroll. Passive listeners cannot themselves preventDefault, so we
  // never block native scroll ourselves.
  function blockResidualTouch(e) {
    var c = e.target && e.target.closest && e.target.closest('xo-carousel');
    if (!c) return;
    if (c.dataset.sawayMobReady !== '1') return;
    e.stopImmediatePropagation();
  }
  ['touchstart', 'touchmove', 'touchend', 'touchcancel'].forEach(function (t) {
    document.addEventListener(t, blockResidualTouch, { capture: true, passive: true });
  });

  document.addEventListener(
    'click',
    function (e) {
      var btn = findArrowFromEvent(e);
      if (!btn) return;
      var carousel = btn.closest && btn.closest('xo-carousel');
      if (!carousel) return;

      var isNativeMobile =
        carousel.dataset.sawayMobReady === '1' ||
        (mobileMql.matches && carousel.hasAttribute('data-saway-native-mobile'));

      if (isNativeMobile && carousel.dataset.sawayMobReady === '1') {
        e.stopImmediatePropagation();
        e.preventDefault();
        var tag = btn.tagName.toLowerCase();
        var dir =
          tag === 'xo-carousel-next' || btn.classList.contains('saway-mob-next')
            ? 1
            : -1;
        nativeStep(carousel, dir);
        return;
      }

      if (carousel.__sawayBusy) {
        e.stopImmediatePropagation();
        e.preventDefault();
        return;
      }
      carousel.__sawayBusy = true;
      carousel.setAttribute('data-saway-busy', '1');
      setTimeout(function () {
        carousel.__sawayBusy = false;
        carousel.removeAttribute('data-saway-busy');
      }, getBusyMs(carousel));
    },
    true
  );
})();
